// extracted by mini-css-extract-plugin
module.exports = {"banner":"analytics_banner__10eZF","buttons":"analytics_buttons__1cw7J","ghost":"analytics_ghost__pChKv","accept":"analytics_accept__2Zhve"};